import { render, staticRenderFns } from "./solution-diChanFengKong.vue?vue&type=template&id=8e79a9ec&scoped=true&"
import script from "./solution-diChanFengKong.vue?vue&type=script&lang=js&"
export * from "./solution-diChanFengKong.vue?vue&type=script&lang=js&"
import style0 from "./solution-diChanFengKong.vue?vue&type=style&index=0&id=8e79a9ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e79a9ec",
  null
  
)

export default component.exports